import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getLogoutUser } from '../redux/slices/auth-slice';

const AutoLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.loginUserReducer);

  const timeout = user?.routesConfig?.values?.sessionTimeOutValue || (10 * 60 * 1000);

  useEffect(() => {
    let timer;
    
    // Function to reset the timer whenever there's activity
    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        if (user) {
          dispatch(getLogoutUser());
        }
      }, timeout);
    };

    // Add event listeners to track user activity
    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];
    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // Set initial inactivity timer
    resetTimer();

    // Cleanup the event listeners on component unmount
    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (timer) clearTimeout(timer);
    };
  }, [dispatch, navigate, user, timeout]);

  return null;
};

export default AutoLogout;
